// @flow
import { TableCell, TableRow } from '@mui/material';
import { collapsibleTableHead, collapsibleTableRow, tableHead, tableRow } from '@shared/style/table';

function TableHeadCell({ children, ...props }: { children: React$Node }): React$Node {
	return (
		<TableCell sx={tableHead} {...props}>
			{children}
		</TableCell>
	);
}

function TableBodyRow({ children, ...props }: { children: React$Node }): React$Node {
	return (
		<TableRow sx={tableRow} {...props}>
			{children}
		</TableRow>
	);
}

function CollapsibleTableHeadCell({ children, ...props }: { children: React$Node }): React$Node {
	return (
		<TableCell sx={collapsibleTableHead} {...props}>
			{children}
		</TableCell>
	);
}

function CollapsibleTableBodyRow({ children, ...props }: { children: React$Node }): React$Node {
	return (
		<TableRow sx={collapsibleTableRow} {...props}>
			{children}
		</TableRow>
	);
}

export { TableHeadCell, TableBodyRow, CollapsibleTableHeadCell, CollapsibleTableBodyRow };
